import { render, staticRenderFns } from "./FatigaEntradaRecepcion.vue?vue&type=template&id=080036fe&scoped=true"
import script from "./FatigaEntradaRecepcion.vue?vue&type=script&lang=js"
export * from "./FatigaEntradaRecepcion.vue?vue&type=script&lang=js"
import style0 from "./FatigaEntradaRecepcion.vue?vue&type=style&index=0&id=080036fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080036fe",
  null
  
)

export default component.exports